<section class="section section-shaped">
  <div class="container">
    <div class="text-primary text-underline cursor-pointer back-button h5" (click)="back()">
      {{ 'common.back' | translate }}
    </div>
    <div class="title text-center mb-5">{{ 'campaign.campaignDetails' | translate }}</div>
    @if (campaign) {
      <app-campaign-info [campaignInfo]="campaign?.campaignInfo" [tabs]="campaignMenus">
      </app-campaign-info>
      @if (
        campaign?.campaignInfo?.useAiDesign &&
        campaign?.campaignInfo?.gammaEmbedUrl &&
        environment.flagToUseGammaAIEmbeddedContent
      ) {
        <div>
          <div class="tw-mb-12 tw-h-[1200px] tw-w-full">
            <iframe
              [src]="campaign.campaignInfo.gammaEmbedUrl | safeUrl"
              width="100%"
              height="100%"
              frameborder="0"
              allowfullscreen
              style="border-radius: 8px; border: none"
            >
            </iframe>
          </div>
        </div>
      }
      @if (campaign.campaignFAQs && campaign.campaignFAQs.length > 0) {
        <div class="section" id="faq">
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <div class="title-red">
                {{ 'campaign.faq' | translate }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-faqs [faqs]="campaign.campaignFAQs"></app-faqs>
            </div>
          </div>
        </div>
      }
      @if (campaign.campaignRisks && campaign.campaignRisks.length > 0) {
        <div class="section" id="risks">
          <div class="row">
            <div class="col-12 d-flex justify-content-center">
              <div class="title-red">
                {{ 'campaign.risks' | translate }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-risks [risks]="campaign.campaignRisks"></app-risks>
            </div>
          </div>
        </div>
      }
    }
    @if (!campaign) {
      <agmo-loading></agmo-loading>
    }
  </div>
</section>
